import type { OutboxOperation } from '$db/local/db';

/**
 * Orden topológico de upserts para no romper FKs padre→hijo en remoto.
 * El orden inverso se usa para deletes.
 */
export const UPSERT_ORDER: string[] = [
  'preferences',
  'studyGoal',
  'nodeTemplate',
  'node',
  'macroSession',
  'problemAttempt',
  'recallItem',
  'reviewEvent',
  'memoryWeights',
  'conjecture',
  'sleepRecord'
];

const RANK: Record<string, number> = Object.fromEntries(
  UPSERT_ORDER.map((t, i) => [t, i])
);

function rankOf(entityType: string): number {
  return RANK[entityType] ?? 9999;
}

/**
 * Ordena un batch de ops para envío al RPC:
 *   1) Upserts primero, en orden topológico padre→hijo.
 *   2) Deletes después, en orden inverso (hijo→padre).
 *   3) Dentro de cada grupo y tipo, por createdAt ascendente.
 */
export function sortOpsForPush(ops: OutboxOperation[]): OutboxOperation[] {
  const upserts = ops.filter((o) => o.op === 'upsert');
  const deletes = ops.filter((o) => o.op === 'delete');

  upserts.sort((a, b) => {
    const r = rankOf(a.entityType) - rankOf(b.entityType);
    if (r !== 0) return r;
    return a.createdAt.localeCompare(b.createdAt);
  });

  deletes.sort((a, b) => {
    const r = rankOf(b.entityType) - rankOf(a.entityType);
    if (r !== 0) return r;
    return a.createdAt.localeCompare(b.createdAt);
  });

  return [...upserts, ...deletes];
}